<div [ngSwitch]="data.variant"
     class="bg-col-w p-a-3">
    <div class="flex flex-justify-between flex-middle">
        <p class="h4 col-1">
            {{data.title | translate}}
        </p>
        <button aria-label="Close"
                class="inline-flex"
                (click)="close()">
            <i class="icon-close inline-flex col-12"
               [style.fontSize.px]="14"
               aria-hidden="true"></i>
        </button>
    </div>
    @if(data.copy){
    <div class="col-1 p1 m-t-2"> {{ data.copy }}</div>
    }
    @if(data.variant === 'basket' && data.basketItem){
    <div class="b-t b-col-4 m-t-2">
        <basket-notification-item class="w-12 m-t-2"
                                  [item]="data.basketItem"
                                  [variant]="'notification'"></basket-notification-item>
    </div>
    }
</div>